import { Input } from '@/components/shadcn/input'
import type { PropertyEditorProps } from '@/lib/action-modules/registry/subtypes/types'

export default function TextPropertyEditor(props: PropertyEditorProps) {
  return (
    <Input
      value={(props.value as string) ?? ''}
      placeholder={props.property.defaultValue?.toString() ?? ''}
      onChange={e => props.onChanged(e.target.value)}
    />
  )
}
